
import { gsap } from "gsap";

export default function toggleCommonAnimation(el, forcedDelay = 0) {
    if (!el) return;

    const element = typeof el === "string" ? document.querySelector(el) : el;
    if (!element) return;

    const anim = element.getAttribute("data-animation");
    const animDelay = forcedDelay;

    let animStart = {};
    let animEnd = {};

    element.style.visibility = "visible";
    element.style.willChange = "opacity, transform";

    const isStoryTimeline = Boolean(element.closest(".story-timeline"));
    const storyOffset = isStoryTimeline
        ? Math.max(element.offsetWidth || 0, element.getBoundingClientRect().width || 0, 80)
        : 40;
    const duration = isStoryTimeline ? 1.4 : 0.5;
    const ease = isStoryTimeline ? "power3.out" : "power2.out";

    switch (anim) {
        case "fade-up":
            animStart = { opacity: 0, y: 40 };
            animEnd = { duration, delay: animDelay, opacity: 1, y: 0, ease };
            break;

        case "fade-down":
            animStart = { opacity: 0, y: -40 };
            animEnd = { duration, delay: animDelay, opacity: 1, y: 0, ease };
            break;

        case "fade-left":
            animStart = { opacity: 0, x: storyOffset };
            animEnd = { duration, delay: animDelay, opacity: 1, x: 0, ease };
            break;

        case "fade-right":
            animStart = { opacity: 0, x: -storyOffset };
            animEnd = { duration, delay: animDelay, opacity: 1, x: 0, ease };
            break;

        case "zoom-in":
            animStart = { opacity: 0, scale: 0.85 };
            animEnd = { duration, delay: animDelay, opacity: 1, scale: 1, ease };
            break;

        default:
            animStart = { opacity: 0 };
            animEnd = { duration, delay: animDelay, opacity: 1, ease };
    }

    // Applica subito lo stato iniziale inline per evitare un frame di flash
    // tra la rimozione della classe CSS e l'inizio del tween.
    gsap.set(element, animStart);
    const tween = gsap.to(element, {
        ...animEnd,
        onComplete: () => {
            element.classList.add("animation-complete");
        }
    });

    return tween;
}

export function animateElements(elements, stagger = 0.06) {
    if (!elements) return [];

    const list = elements instanceof NodeList || Array.isArray(elements)
        ? Array.from(elements)
        : [elements];

    return list.map((el, index) => toggleCommonAnimation(el, index * stagger)).filter(Boolean);
}
